import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { IndividualReportsService } from '../services/individual-reports.service';
import { IndTemplateActions } from './indTemplate.actions';
import { mergeMap, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

@Injectable()
export class IndTemplateEffects {
  loadTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IndTemplateActions.loadTemplate),
      mergeMap(({ measureOId }) =>
        this.individualService.getIndividualTemplate(measureOId).pipe(
          map((resultResponse) => {
            if (resultResponse.success) {
              const template = resultResponse.data[0];
              return IndTemplateActions.loadTemplateSuccess({ template });
            } else {
              return IndTemplateActions.loadTemplateFailure({ error: resultResponse.errorText! });
            }
          }),
          catchError((error) => of(IndTemplateActions.loadTemplateFailure({ error: error.message }))),
        ),
      ),
    ),
  );
  saveTemplateBuilder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IndTemplateActions.saveTemplateBuilder),
      mergeMap(({ measureOId, data }) =>
        this.individualService.updateIndividualTemplate(measureOId, data).pipe(
          map((resultResponse) => IndTemplateActions.saveTemplateBuilderSuccess()),
          catchError((error) => of(IndTemplateActions.saveTemplateBuilderFailure({ error: error.message }))),
        ),
      ),
    ),
  );

  showSuccessMessage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(IndTemplateActions.saveTemplateBuilderSuccess),
        tap(() => {
          this.messageService.add({
            severity: 'success',
            summary: 'Saved',
            detail: 'Template saved',
          });
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private individualService: IndividualReportsService,
    private messageService: MessageService,
  ) { }
}

